require('../../../../_lib/jquery.passwordRequirements');
require('./users-tab');
require('./groups-tab');
require('./settings-tab');
require('./notifications-tab');
const addressChangeDetector = require('../../../../common/src/organization/_modifiedAddressDetector');

const userAddEditModal = Router.getController('users.userAddEditModal');

$('body').tooltip({
  selector: '[data-toggle="tooltip"]',
  html: true
});

$(() => {
  let categoryColumn = null;
  const country = $('#accountDetail .select-country').val();
  const menuController = Router.getController('customer.account.menuController');
  menuController.initialize();

  // Report pdf table
  const reportTable = $('#report-pdf-table').DataTable({
    processing: true,
    serverSide: true,
    ajax: urlPdfReportData,
    order: [[1, 'asc']],
    pageLength: 5,
    recordsFiltered: 5,
    bFilter: true,
    lengthChange: false,
    searching: false,
    info: false,
    pagingType: 'simple',
    autoWidth: false,
    columns: [
      { name: 'type' },
      { name: 'date_create', class: 'text-nowrap' },
      { name: 'status', class: 'text-right text-nowrap' }
    ]
  });

  if (typeof urlDownloadsData !== 'undefined') {
    // Report pdf table
    var downloadsTable = $('#downloads-table').DataTable({
      processing: true,
      serverSide: true,
      ajax: urlDownloadsData,
      order: [[1, 'asc']],
      pageLength: 5,
      recordsFiltered: 5,
      bFilter: true,
      lengthChange: false,
      searching: false,
      info: false,
      pagingType: 'simple',
      autoWidth: false,
      columns: [
        { name: 'id_list' },
        { name: 'date_create', class: 'text-nowrap' },
        { name: 'status', class: 'text-right text-nowrap' }
      ]
    });
  }

  setInterval(() => {
    if (menuController.getCurrentTab() === 'downloads') {
      if (downloadsTable) {
        downloadsTable.ajax.reload(null, false);
      }

      if (reportTable) {
        reportTable.ajax.reload(null, false);
      }
    }
  }, 30000);

  changeState('#accountDetail', country);

  $('.pr-password').passwordRequirements();

  $('#accountDetail .select-country').select2({
    placeholder: __('Select Country')
  });

  $('#accountDetail .select-country').on('change', (e) => {
    const country = $('#accountDetail .select-country').val();
    changeState('#accountDetail', country);
  });

  $('#form-organization .select-country').on('change', (e) => {
    const country = $('#form-organization .select-country').val();
    changeState('#form-organization', country);
  });

  $('#accountDetail .select-denomination').select2({
    placeholder: __('Select Denomination')
  });

  $('#accountDetail .select-state').select2({
    placeholder: __('Select State')
  });

  $('#accountDetail select[name="timezone"]').select2({
    placeholder: __('Select Timezone')
  });

  $('#accountDetail .select2-container').on('keypress', function (e) {
    $(this).prev().select2('open');
  });

  $('#form-organization .select-country').select2({
    placeholder: __('Select Country'),
    width: '100%'
  });

  $('#form-organization .select-denomination').select2({
    placeholder: __('Select Denomination'),
    width: '100%'
  });

  $('#form-organization .select-state').select2({
    placeholder: __('Select State'),
    width: '100%'
  });

  $('.category').editable({
    emptytext: 'Current Category',
    success(res) {
      if (res.isError == 1) toastr.error(res.msgError, 'Error');
      else toastr.success(__('Organization has been saved.'), __('Success'));
    }
  });

  const original = $.fn.editableutils.setCursorPosition;
  $.fn.editableutils.setCursorPosition = function () {
    try {
      original.apply(this, Array.prototype.slice.call(arguments));
    } catch (e) { /* noop */ }
  };

  const form = $('#form-organization');
  $('#add-organization-btn').click(() => {
    form.find('.help-block').remove();
    form.find('#add-organization div').removeClass('has-error');

    form.find('#primary-user-row').show();
    form.find('#primary-user-row').show();
  });

  $('a#edit-organization-btn').click(() => {
    form.find('.help-block').remove();
    form.find('#add-organization div').removeClass('has-error');

    form.find('#primary-user-row').hide();
    form.find('#primary-user-row').hide();
  });

  $('#addOrganizationBtn').click(() => {
    const btn = $('#add-organization .modal-footer button');

    const idOrganization = $('#add-organization #addOrganizationBtn').data('id');

    const data = $('#form-organization').serializeJson();
    data.idOrganization = idOrganization;
    data.addLicense = false;
    data.groupId = $('input#groupId').val();

    btn.loading();
    $.post(saveOrganizationUrl, data, () => {
      toastr.success('Organization has been saved.', 'Success');
      $('#add-organization').modal('hide');
      location.reload();
    }, 'json').always(() => {
      btn.loading('reset');
    });
  });

  $('#groups-list').delegate('.btn-edit', 'click', function (e) {
    const btn = $(this);
    const id = btn.data('id');

    btn.button('loading');
    $.post(urlLoadEdit, {
      id
    }, (data, b) => {
      btn.button('reset');

      $('#add-organization  label.control-label').remove();
      $('#add-organization  div.form-group').removeClass('has-error');

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        $('#add-organization #addOrganizationBtn').data('id', id);

        $.each(data, (index, value) => {
          if (index == 'denomination' || index == 'state' || index == 'country' || index == 'is-active') {
            $(`#form-organization .select-${index}`).val(value).trigger('change');
          } else {
            $('#add-organization .form-organization').find(`[name="${index}"]`).val(value);
          }
        });

        const country = $('#form-organization .select-country').val();
        changeState('#form-organization', country);

        $('#add-organization').modal('show');
      }
    });

    e.preventDefault();
  });

  $('.category').on('save', function (e, params) {
    const podcastCheckboxContainer = $(this).parent().parent().find('.podcast-checkbox-container');

    if (params.response.forcePodcast) {
      podcastCheckboxContainer.addClass('force-podcast');
    } else {
      podcastCheckboxContainer.removeClass('force-podcast');
    }
  });

  $('.addOrganization').on('click', () => {
    $('#add-organization #addOrganizationBtn').data('id', '');
    $('#add-organization .form-organization').trigger('reset');
    $('#add-organization  label.control-label').remove();
    $('#add-organization  div.form-group').removeClass('has-error');
    $('#form-organization .select-state, #form-organization .select-country, #form-organization .select-denomination').val('').trigger('change');
  });

  $('#groups-list').delegate('.btn-remove', 'click', function (e) {
    const btn = $(this);
    const id = btn.data('id');
    btn.button('loading');

    bootbox.confirm({
      title: __('Remove from group'),
      message: __('Are you sure this organization should be removed from group?'),
      buttons: {
        cancel: {
          label: `<i class="fa fa-times"></i> ${__('No')}`,
          className: 'btn-default btn-dark'
        },
        confirm: {
          label: `<i class="fa fa-check"></i> ${__('Yes')}`,
          className: 'btn-primary btn btn-space'
        }
      },
      callback(result) {
        if (result) {
          $.post(urlRemoveOrganizationGroup, {
            id
          }, (data, b) => {
            btn.button('reset');

            if (data.isError == 1) {
              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success(__('Organization has been removed from group.'), __('Success'));
              location.reload();
            }
          });
        } else {
          btn.button('reset');
        }
      }
    });

    e.preventDefault();
  });

  $('#accountDetail').submit(function (e) {
    if (addressChangeDetector.isChanged() && hasUnpaidLicenses) {
      bootbox.confirm({
        title: __('Address changed'),
        message: __('Do you want to apply this Profile Address update to the current unpaid invoices?'),
        buttons: {
          confirm: {
            label: __('Yes'),
            className: 'btn-primary'
          },
          cancel: {
            label: __('No, only future invoices'),
            className: 'btn-cancel'
          }
        },
        callback(result) {
          postAccountDetail(result);
        }
      });
    } else {
      postAccountDetail(false);
    }

    e.preventDefault();
  });

  function postAccountDetail(updateInvoiceAddresses) {
    const updateForm = $('#accountDetail');
    const $btn = updateForm.find('button').button('loading');

    $('#accountDetail label.control-label').remove();
    $('#accountDetail div.form-group').removeClass('has-error');

    const dataArr = updateForm.serializeJson();
    dataArr.updateInvoiceAddresses = updateInvoiceAddresses;

    $.post(updateUrl, { dataArr }, (data) => {
      $btn.button('reset');

      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else if (data.formErrorMessagess.length !== 0) {
        $.each(data.formErrorMessagess, (elementId, value) => {
          $.each(value, (index, value) => {
            updateForm.find(`input[name="${elementId}"]`).parent().addClass('has-error');
            updateForm.find(`input[name="${elementId}"]`).after(`<label style="display:block;" for="${elementId}" generated="true" class="control-label">${value}</label>`);
          });
        });

        toastr.error(__('Form has errors'), 'Error');
      } else {
        addressChangeDetector.updateAddress();
        toastr.success(__('Organization Profile has been successfully updated'), __('Success'));
      }
    });
  }

  $('#updateProfile').submit(function (e) {
    const btn = $(this).find('button');

    $('#updatePassword label.control-label').remove();
    $('#updatePassword div.form-group').removeClass('has-error');

    const updateForm = $(this);
    const data = $(this).serializeJson();

    btn.loading();
    $.post(updateProfileUrl, data).success(() => {
      updateForm.find('input[name="password"]').val('');
      updateForm.find('input[name="re-password"]').val('');
      toastr.success(__('Account has been successfully updated'), __('Success'));
      setTimeout(() => {
        location.reload();
      }, 2000);
    }).always(() => {
      btn.loading('reset');
    });

    e.preventDefault();
  });

  $('#updateServices').submit(function (e) {
    const $btn = $(this).find('button');
    $btn.loading();

    $('#updateServices label.control-label').remove();
    $('#updateServices div.form-group').removeClass('has-error');

    const updateForm = $(this);
    const dataArr = $(this).serializeArray();

    $.post(updateServicesUrl, { dataArr }).success(() => {
      updateForm.find('input[name="password"]').val('');
      updateForm.find('input[name="re-password"]').val('');
      toastr.success(__('Services have been successfully updated'), __('Success'));
    }).always(() => {
      $btn.loading('reset');
    });

    e.preventDefault();
  });

  $('#defaultHymnals').submit(function (e) {
    const $btn = $(this).find('button').button('loading');

    $('#defaultHymnals label.control-label').remove();
    $('#defaultHymnals div.form-group').removeClass('has-error');

    const hymnalsForm = $(this);
    const dataArr = $(this).serializeArray();

    $.post(updateHymnalsUrl, { dataArr }, (data) => {
      $btn.button('reset');

      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        toastr.success(__('Hymnals have been successfully updated'), __('Success'));
      }
    });

    e.preventDefault();
  });

  $('.send-packet').click(function (e) {
    const invoiceId = $(this).data('number');
    const modal = $('#sendWelcomeEmail');

    modal.find('#sendWelcomeEmailBtn').data('invoice-id', invoiceId);

    modal.modal('show');

    e.preventDefault();
  });

  $('#submit-podcast').click(() => {
    bootbox.confirm({
      title: __('Podcast confirmation'),
      message: __('Are you sure to add podcast to your license?'),
      buttons: {
        confirm: {
          label: __('Yes'),
          className: 'btn-primary'
        },
        cancel: {
          label: __('No'),
          className: 'btn-cancel'
        }
      },
      callback(result) {
        if (result) {
          $('#submit-podcast').button('loading');

          const invoice = $('#submit-podcast').data('id-invoice');

          $.post(addPodcastUrl, {
            invoice
          }, (data, b) => {
            if (data.isError == 1) {
              $('#submit-podcast').button('reset');

              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success(__('License has been successfully upgraded to Podcast'), __('Success'));

              location.reload();
            }
          });
        }
      }
    });
  });

  $('#submit-recording').click(() => {
    bootbox.confirm({
      title: __('Recorded Audio confirmation'),
      message: __('Are you sure to add recorded audio to your license?'),
      buttons: {
        confirm: {
          label: __('Yes'),
          className: 'btn-primary'
        },
        cancel: {
          label: __('No'),
          className: 'btn-cancel'
        }
      },
      callback(result) {
        if (result) {
          $('#submit-recording').button('loading');

          const invoice = $('#submit-recording').data('id-invoice');

          $.post(addRecordingUrl, {
            invoice
          }, (data, b) => {
            if (data.isError == 1) {
              $('#submit-recording').button('reset');

              toastr.error(data.msgError, 'Error');
            } else {
              toastr.success(__('License has been successfully upgraded to Recorded Audio'), __('Success'));

              location.reload();
            }
          });
        }
      }
    });
  });

  $('a#edit-organization-users-btn').click(function (e) {
    const btn = $(this);
    const id = btn.data('id');
    btn.button('loading');

    userAddEditModal.show({ organizationId: id }, () => {
      btn.button('reset');
    });

    e.preventDefault();
  });

  $('#groups-list').delegate('.btn-reprint-renewal', 'click', function (e) {
    const rfcBtn = $(this).parent().parent().parent()
        .parent()
        .find('.dropdown');
    const gifLoader = $(this).parent().parent().parent()
        .parent()
        .find('.gif-loader');
    const id = $(this).data('id');

    categoryColumn = rfcBtn.parent().prev().prev().prev();

    rfcBtn.hide();
    gifLoader.show();

    $.post(loadEditReprintRenewalUrl, {
      id
    }, (data, b) => {
      gifLoader.hide();
      rfcBtn.show();

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        currentOrganization = data.id;
        $('#editRenewalCategory .modal-body').html(data.html);
        $('#editRenewalCategory').modal('show');
      }
    });

    e.preventDefault();
  });

  $('#editRenewalCategory').delegate('#renewal-category', 'change', function (e) {
    if ($('#renewal-podcast').length > 0) {
      const label = $(this).find(':selected').text();

      if (label.includes('Limited Podcast')) {
        $('#renewal-podcast').prop('disabled', true);
        $('#renewal-podcast').prop('checked', true);
      } else {
        $('#renewal-podcast').prop('disabled', false);
        $('#renewal-podcast').prop('checked', false);
      }
    }
  });

  $('#editRenewalCategory').on('hidden.bs.modal', function (e) {
    categoryColumn = null;
  });

  $('#saveReprintRenewal').click(function (e) {
    e.preventDefault();

    const saveButton = $(this);
    const gifLoader = saveButton.parent().find('.gif-loader').first();
    const podcast = $('#renewal-podcast').length > 0 ? $('#renewal-podcast').is(':checked') : false;
    const recording = $('#renewal-recording').length > 0 ? $('#renewal-recording').is(':checked') : false;

    saveButton.parent().find('button').hide();
    gifLoader.show();

    $.post(editReprintRenewalUrl, {
      idOrganization: currentOrganization,
      idRenewalLicense: $('#renewal-category').val(),
      podcasted: podcast,
      recording
    }, (data, b) => {
      saveButton.parent().find('button').show();
      gifLoader.hide();

      if (data.isError == 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        categoryColumn.html(data.category);
        $('#editRenewalCategory').modal('hide');

        toastr.success(__('Reprint Renewal Updated.'));
      }
    });
  });

  function changeState(form, country) {
    const selectedOption = $(`${form} select[name=country]`).find('option:selected');
    const stateDropdown = $(`${form} select[name=state]`);
    const stateText = $(`${form} input[name=stateInput]`);

    if (selectedOption.attr('data-states-count') > 0) {
      if (stateDropdown.is(':visible')) {
        stateDropdown.prop('disabled', true);
      } else if (stateText.is(':visible')) {
        stateText.prop('disabled', true);
      }
      $('.state-loader').show();

      $.get(`${getStatesByCountryUrl}/${selectedOption.attr('value')}`, {

      }, (data) => {
        if (data.isError === 1) {
          toastr.error(data.msgError, 'Error');
        } else {
          stateDropdown.prop('disabled', false);
          $('.state-loader').hide();
          stateText.closest('.form-group').hide();
          stateText.val('');
          const currentState = stateDropdown.val();

          stateDropdown.find('option').remove();
          $.each(data.states, (i, item) => {
            const attr = {
              value: item.code,
              text: item.name
            };
            if (item.code === currentState) {
              attr.selected = 'selected';
            }
            stateDropdown.append($('<option>', attr));
          });
          stateDropdown.closest('.form-group').show();
          stateDropdown.select2({
            placeholder: __('Select State'),
            sorter(data) {
              return data.sort((a, b) => {
                if (a.text > b.text) {
                  return 1;
                }
                if (a.text < b.text) {
                  return -1;
                }
                return 0;
              });
            }
          });
        }
      }, 'json');
    } else {
      stateText.prop('disabled', false);
      $('.state-loader').hide();
      stateText.closest('.form-group').show();
      stateDropdown.val('');
      stateDropdown.closest('.form-group').hide();
    }

    const navAccount = $('#navbar-account');
    navAccount.on('click', 'a', null, () => {
      if (window.matchMedia('(max-width: 767px)').matches) navAccount.collapse('hide');
    });
  }

  $('.btn-license-history').click(function (e) {
    $(this).addClass('loader');
  });

  $('.view-invoice a').click(function (e) {
    $(this).closest('.dropdown').hide();
    $(this).closest('.col-sm-6').find('img').show();
    $(this).closest('.col-sm-6').find('.unpaid-invoice-indicator').hide();
  });

  $('.unpaid-invoice-indicator').click(function (e) {
    $(this).closest('.col-sm-6').find('.dropdown').hide();
    $(this).closest('.col-sm-6').find('img').show();
    $(this).hide();
  });

  $('#print-group-report-btn').click(() => {
    $.get(urlGroupReport, (data) => {
      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        menuController.activateTab('downloads');
      }
    }, 'json');
  });

  $('a#print-year-report-btn').click(function (e) {
    e.preventDefault();
    const organizationId = $(this).data('id');

    $.get(`${urlYearReport}/${organizationId}`, (data) => {
      if (data.isError === 1) {
        toastr.error(data.msgError, 'Error');
      } else {
        menuController.activateTab('downloads');
      }
    }, 'json');
  });

  menuController.el.on('tab-activated', (el, tab) => {
    if (tab === 'downloads') {
      reportTable.ajax.reload(null, false);
    }
  });
});
